import axios from "axios";
import Constants from "../../../components.constants.js";


export default {

  async getAllAuditLogsFromServer(context, payload = {}) {
    try {
      let logsUrl = Constants.sessionUserAuditTrailUrl;
      if(payload.isPrivExists){
        logsUrl = Constants.auditTrailUrl;
      }
      delete payload["isPrivExists"]
      let resp = await axios.get(logsUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAllAuditLogsFromServer][Store][Error occured while getting audit logs list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },


  async getAuditLogInfoFromServer(context, payload = {}) {
    //payload : {params:{auditLogId:"3422344231"}}

    try {
      let resp = await axios.get(`${Constants.auditTrailUrl}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAuditLogInfoFromServer][Store][Error occured while getting specific audit log --->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async downloadAuditTrailReportFromServer(context,payload = {}) {
    try {
      let resp = await axios.get(Constants.downloadauditTrailReportUrl, payload);
      // let resp = await axios.get(`${Constants.downloadauditTrailReportUrl}/${payload.params.auditLogId}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        return resp;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getDownloadAuditTrailReportFromServer][Store][Error occured while getting Download Audit trail report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async downloadSessionAuditTrailReportFromServer(context,payload = {}) {
    try {
      let resp = await axios.get(Constants.sessionauditTrailReportUrl, payload);
      // let resp = await axios.get(`${Constants.sessionauditTrailReportUrl}/${payload.params.auditLogId}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        return resp;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getDownloadAuditTrailReportFromServer][Store][Error occured while getting Download Audit trail report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  
};
